import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { Module } from '../../modules/module.interface';
import { Role } from '../../modules/roles/role.interface';

export class RoleService {
   async getRoles(tenantId: number) {
      const response = await http.get<ApiResource<Role>>(`/tenants/${tenantId}/roles`);
      return response.data;
   }

   async postRolesBatch(tenantId: number, roles: Array<Role>) {
      const response = await http.post<Array<Module>>(`/tenants/${tenantId}/roles-batch`, { roles });
      return response.data;
   }

   async deleteRolesBatch(tenantId: number, roles: Array<Role>) {
      const response = await http.delete<Array<Module>>(`/tenants/${tenantId}/roles-batch`, { data: { roles } });
      return response.data;
   }

   async getRole() {
      throw Error('Method not implemented');
   }

   async postRole() {
      throw Error('Method not implemented');
   }

   async putRole() {
      throw Error('Method not implemented');
   }

   async deleteRole() {
      throw Error('Method not implemented');
   }
}
